/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: not all required document sides were provided
 * @export
 * @interface PaxCheckNotAllSidesScannedError
 */
export interface PaxCheckNotAllSidesScannedError {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckNotAllSidesScannedError
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckNotAllSidesScannedError interface.
 */
export function instanceOfPaxCheckNotAllSidesScannedError(value: object): value is PaxCheckNotAllSidesScannedError {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckNotAllSidesScannedErrorFromJSON(json: any): PaxCheckNotAllSidesScannedError {
    return PaxCheckNotAllSidesScannedErrorFromJSONTyped(json, false);
}

export function PaxCheckNotAllSidesScannedErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckNotAllSidesScannedError {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function PaxCheckNotAllSidesScannedErrorToJSON(json: any): PaxCheckNotAllSidesScannedError {
    return PaxCheckNotAllSidesScannedErrorToJSONTyped(json, false);
}

export function PaxCheckNotAllSidesScannedErrorToJSONTyped(value?: PaxCheckNotAllSidesScannedError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

